<template>
    <div class="modal fade modern-modal" tabindex="-1" id="CadatroUnidade" ref="modalCadatroUnidade">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-modern">
            <div class="modal-content modal-modern-content border-0">
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                        data-bs-dismiss="modal"
                        type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>

                <div class="modal-modern-header">
                    <div class="header-icon">
                        <i class="fas fa-building"></i>
                    </div>
                    <div class="header-text">
                        <h2>{{ dados && dados.idUnidade ? 'Editar unidade' : 'Nova unidade' }}</h2>
                        <p>Preencha os campos para {{ dados && dados.idUnidade ? 'atualizar' : 'cadastrar' }} a unidade.</p>
                    </div>
                </div>

                <div class="modal-modern-body">
                    <form id="formCadastroUnidade" v-if="dados" novalidate>
                        <div class="form-grid form-grid-2">
                            <div class="form-group">
                                <label class="form-label" for="unidade.cdUnidade">Código</label>
                                <input type="text"
                                       class="form-control"
                                       id="unidade.cdUnidade"
                                       name="unidade.cdUnidade"
                                       v-model="unidade.cdUnidade"
                                       maxlength="50"
                                       placeholder="Digite o código da unidade"
                                       required>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="unidade.nmUnidade">Nome</label>

                                <input type="text"
                                       class="form-control"
                                       id="unidade.nmUnidade"
                                       name="unidade.nmUnidade"
                                       v-model="unidade.nmUnidade"
                                       maxlength="100"
                                       placeholder="Digite o nome do unidade"
                                       required>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="modal-modern-footer">
                    <button class="btn btn-primary btn-modern-primary w-100"
                            type="button"
                            :disabled="!liberaSalvar"
                            @click="enviar">
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'CadatroUnidade',
        components: {
        },
        data: function () {
            return {

                resultConsulta: null,
                unidade: {
                    idUnidade: 0,
                    nmUnidade: null,
                    cdUnidade: null,
                },

                modal: null,
            }
        },
        props: {
            showModal: Boolean,
            dados: Object,
        },
        computed: {
            liberaSalvar() {
                if (this.unidade.nmUnidade == '' || this.unidade.nmUnidade == null) {
                    return false;
                }

                if (this.unidade.cdUnidade == '' || this.unidade.cdUnidade == null) {
                    return false;
                }

                return true;
            },

        },
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Unidade/Post`, $this.unidade)
                        .then(res => {
                            if (res.data.success) {
                                // aviso ok
                                avisoSucesso("Dados salvos com sucesso!");
                                $this.modal.hide();

                                $this.$emit('reload');
                                $this.$emit('close');
                            } else {
                                avisoErro("Não foi possível salvar os dados.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                var msg = res.response.data.msg + ' ' + (res.response.data.errors.length > 0 ? res.response.data.errors[0] : '');
                                avisoErro(msg);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            checkForm() {
                var form = document.getElementById('formCadastroUnidade')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                if (this.unidade.nmUnidade.length > 100) {
                    avisoErro("O limite de caracteres do \"Nome\" foi ultrapassado")
                    return false;
                }

                if (this.unidade.cdUnidade.length > 100) {
                    avisoErro("O limite de caracteres \"Código\" foi ultrapassado")
                    return false;
                }

                return true;
            },

            load() {
                let $this = this;
                $this.unidade = {
                    idUnidade: 0,
                    nmUnidade: null,
                    cdUnidade: null,
                };
                if ($this.dados.idUnidade) {
                    axios.get(`${urlApi}/Unidade/Get/${this.dados.idUnidade}`)
                        .then(res => {
                            if (res.data.success) {
                                var result = res.data.data;
                                $this.resultConsulta = result;

                                $this.unidade = {
                                    idUnidade: result.idUnidade,
                                    nmUnidade: result.nmUnidade,
                                    cdUnidade: result.cdUnidade,
                                };

                            } else {
                                avisoErro("Não foi possível carregar os dados.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                
            },

            close() {
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalCadatroUnidade);
                }
                this.modal.hide();
            }

        },
        mounted: function () {
            //this.load();
            const esperaBoootstrap = () => {
                if (window.bootstrap && window.bootstrap.Modal) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalCadatroUnidade);
                } else {
                    setTimeout(esperaBoootstrap, 50)
                }
            }
            this.$nextTick(() => esperaBoootstrap());
        },
        watch: {
            showModal: function () {
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalCadatroUnidade);
                }
                this.modal.show();

                this.load();
            },

        }

    };
</script>

<style scoped>
    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        z-index: 10;
    }

        .btn-close-modern:hover {
            transform: scale(1.05);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
            border-color: transparent !important;
        }

            .btn-close-modern:hover svg {
                color: #ffffff;
            }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
    }

        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

        .modal-modern-header .header-icon {
            width: 64px;
            height: 64px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
            color: #2563eb;
        }

        .modal-modern-header .header-text h2 {
            margin: 0;
            font-size: 24px;
            font-weight: 700;
            color: #0f172a;
        }

        .modal-modern-header .header-text p {
            margin-top: 6px;
            margin-bottom: 0;
            color: #475569;
            font-size: 14px;
            max-width: 420px;
            line-height: 1.4;
        }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-modern-primary {
        border: none;
        border-radius: 12px;
        padding: 14px 20px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-modern-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
        }

        .btn-modern-primary:active {
            transform: translateY(0);
        }

    .modern-modal .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        margin-bottom: 10px;
    }

        .modern-modal .form-control:focus {
            border-color: rgba(37, 99, 235, 0.6);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
            background: #ffffff;
        }

    .modern-modal select.form-control {
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .modern-modal .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
    }

    .admin-card {
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.06) 0%, rgba(0, 208, 132, 0.06) 100%);
        border: 2px solid rgba(31, 123, 255, 0.18);
        border-radius: 16px;
        padding: 20px 22px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        transition: all 0.3s ease;
    }

        .admin-card:hover {
            border-color: rgba(31, 123, 255, 0.35);
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.18);
        }

    .admin-title {
        font-weight: 700;
        color: #1f2937;
        text-transform: uppercase;
        font-size: 13px;
        letter-spacing: 0.5px;
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    .admin-checkbox-label {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        position: relative;
        cursor: pointer;
        margin: 0;
        width: fit-content;
    }

    .admin-checkbox-input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .admin-checkbox-custom {
        width: 26px;
        height: 26px;
        border: 2px solid #cbd5e0;
        border-radius: 8px;
        position: relative;
        transition: all 0.3s ease;
        background: #ffffff;
    }

        .admin-checkbox-custom::after {
            content: '';
            position: absolute;
            left: 7px;
            top: 4px;
            width: 7px;
            height: 12px;
            border: solid white;
            border-width: 0 3px 3px 0;
            transform: rotate(45deg);
            opacity: 0;
            transition: opacity 0.2s ease;
        }

    .admin-checkbox-input:checked ~ .admin-checkbox-custom {
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        border-color: transparent;
        box-shadow: 0 6px 16px rgba(31, 123, 255, 0.35);
    }

        .admin-checkbox-input:checked ~ .admin-checkbox-custom::after {
            opacity: 1;
        }

    .admin-checkbox-label:hover .admin-checkbox-custom {
        border-color: #1f7bff;
        box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.12);
    }

    .admin-checkbox-text {
        font-weight: 600;
        font-size: 15px;
        color: #1f2937;
    }

    .admin-checkbox-hint {
        display: block;
        color: #6b7280;
        font-size: 13px;
        margin-left: 38px;
    }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

            .modal-modern-header::after {
                left: 20px;
                right: 20px;
            }

            .modal-modern-header .header-icon {
                width: 56px;
                height: 56px;
            }

        .admin-checkbox-hint {
            margin-left: 0;
        }
    }

    @media (max-width: 576px) {
        .modern-modal .modal-dialog {
            margin: 12px;
        }

        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-body {
        background: transparent;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modern-modal .form-control:focus {
            background: rgba(15, 23, 42, 0.95);
        }

    [data-bs-theme="dark"] .modern-modal select.form-control {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    [data-bs-theme="dark"] .modern-modal .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .admin-card {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.14) 0%, rgba(45, 212, 191, 0.14) 100%);
        border-color: rgba(59, 130, 246, 0.35);
    }

    [data-bs-theme="dark"] .admin-checkbox-text {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .admin-checkbox-hint {
        color: #94a3b8;
    }

    
</style>

